export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14243.72464d6e.jpg";